import "./SatDesignerBottomBar.scss";
import { useState, useEffect } from "react";
import { SmallSatelliteIcon, MagnetIcon, Rotate3dIcon, PaletteIcon } from "../SatelliteProfileImgAssets/SatelliteProfileImgAssets";
import CustomToolTip from "../../../../CommonComponents/CustomToolTip";

const SatDesignerBottomBar = ({ setControlMode, setSelectedMesh, controlMode }) => {

  const [selectedBottomBarItem, setSelectedBottomBarItem] = useState({ ControlMode: false, Magnet: false, Rotate3d: false, Palette: false });

  const setItem = (item) => {
    setSelectedMesh('')
    if (item === "ControlMode") {
      setSelectedBottomBarItem({ ControlMode: true, Magnet: false, Rotate3d: false, Palette: false });
      setControlMode(true);
    }
    else if (item === "Magnet") {
      setSelectedBottomBarItem({ ControlMode: false, Magnet: true, Rotate3d: false, Palette: false });
      setControlMode(false);
    }
    else if (item === "Rotate3d") {
      setSelectedBottomBarItem({ ControlMode: false, Magnet: false, Rotate3d: true, Palette: false });
      setControlMode(false);
    }
    else if (item === "Palette") {
      setSelectedBottomBarItem({ ControlMode: false, Magnet: false, Rotate3d: false, Palette: true });
      setControlMode(false);
    }
  };

  useEffect(() => {
    if (controlMode) {
      // Highlight Satellite Icon in bottom bar initially when sat model is loaded 
      setSelectedBottomBarItem({ ControlMode: true, Magnet: false, Rotate3d: false, Palette: false });
    }
    else {
      // Remove highlight state if any sensor is selected from tree
      setSelectedBottomBarItem({ ControlMode: false, Magnet: false, Rotate3d: false, Palette: false });
    }
  }, [controlMode]);

  return (
    <>
      <div className="satDesignerBottomBar">
        <button onClick={() => setItem("ControlMode")} className={selectedBottomBarItem.ControlMode ? "active" : ""}>
          <CustomToolTip title='Satellite' placement='top'>
            <SmallSatelliteIcon />
          </CustomToolTip>
        </button>
        {/* currently not integrating these buttons at bottom bar */}
        {/* <button onClick={() => setItem("")} className={selectedBottomBarItem.Magnet ? "active" : ""}>
          <CustomToolTip title='Magnet' placement='top'>
            <MagnetIcon />
          </CustomToolTip>
        </button>
        <button onClick={() => setItem("")} className={selectedBottomBarItem.Rotate3d ? "active" : ""}>
          <CustomToolTip title='Rotate 3D' placement='top'>
            <Rotate3dIcon />
          </CustomToolTip>
        </button>
        <button onClick={() => setItem("")} className={selectedBottomBarItem.Palette ? "active" : ""}>
          <CustomToolTip title='Palette' placement='top'>
            <PaletteIcon />
          </CustomToolTip>
        </button> */}
      </div>
    </>
  );
};
export default SatDesignerBottomBar;
